import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import { addQuality, removeQuality, setContentSource } from 'Pods/SearchPage/Store/actions/qualityContent'
import { QUALITY_LEVEL, CONTENT_SOURCE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import I18n from 'Pods/Shared/I18n'

import { qualityLevels, contentSources } from './constants'

const translate = (key) => I18n.t(key, { ns: 'rails' })

const DEFAULT_QUALITY = [QUALITY_LEVEL.ANY]

const buildOptions = (keyspace, items) => items.map((item) => ({
  value: item.value,
  label: item.icon
    ? (
        <span className="filter-wrapper__option--with-icon">
          <Icon notSpaced svgComponent={item.icon} color="primary" size="small" />
          <span>{translate(`search_page.filters.quality.${keyspace}.${item.labelKey}`)}</span>
        </span>
      )
    : translate(`search_page.filters.quality.${keyspace}.${item.labelKey}`),
}))

// hideQualityLabel drops only the Quality group's title/tooltip when an external title already
// names the group (desktop md overflow, mobile collapsible header). Content source keeps its label.
function QualityContent({ hideQualityLabel = false }) {
  const quality = useSearchPageStore(state => state.quality ?? DEFAULT_QUALITY)
  const contentSource = useSearchPageStore(state => state.contentSource ?? CONTENT_SOURCE.ALL)

  const handleQualityFilterChange = useCallback((_, value, isOn) => {
    if (isOn) {
      addQuality(value)
    } else {
      removeQuality(value)
    }
  }, [])

  const handleContentSourceFilterChange = useCallback((_, value) => {
    setContentSource(value)
  }, [])

  const qualityConfig = useMemo(() => [{
    label: hideQualityLabel ? '' : translate('search_page.filters.quality.title'),
    // Copy is from the Figma design and pending review with designers (see RailsEn).
    tooltip: hideQualityLabel ? undefined : translate('search_page.filters.quality.tooltip'),
    tooltipPlacement: 'bottom',
    tooltipContainerClassName: 'quality-filter__tooltip',
    filters: buildOptions('levels', qualityLevels),
  }], [hideQualityLabel])

  const contentSourceConfig = useMemo(() => [{
    label: translate('search_page.filters.quality.content_source_title'),
    filters: buildOptions('content_source', contentSources),
  }], [])

  const selectedContentSource = useMemo(() => [contentSource], [contentSource])

  return (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={qualityConfig}
        selectedFilters={quality}
        onFiltersChange={handleQualityFilterChange}
        isControlled
        useNewCheckboxes
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
      <FiltersSidebar
        isCollapsible={false}
        filters={contentSourceConfig}
        selectedFilters={selectedContentSource}
        onFiltersChange={handleContentSourceFilterChange}
        hideLastDivider
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
        useRadio
      />
    </>
  )
}

QualityContent.propTypes = {
  hideQualityLabel: bool,
}

export default memo(QualityContent)
